import {useTranslation} from "react-i18next";
import SectionDivider from "./common/SectionDivider";
import {products} from "../data/data";
import {useState} from "react";
import {Link} from "react-router-dom";

function CustomerBrandSection() {
    const {t} = useTranslation();
    const [product, setProduct] = useState(products[0]);
    const onProductChanged = (product) => {
        setProduct(product);
    }
    return (
        <div className="section">
            <h1 data-aos="fade-right"
                data-aos-duration="300">
                {t('customer_header')}
            </h1>
            <SectionDivider/>
            <ProductTab products={products} selectedProduct={product}
                        onProductChange={onProductChanged}/>
            <div className="flex flex-wrap justify-center max-w-screen-xl space-x-1 space-y-1 pt-4">
                {product.customers.map((customer, index) => (
                    <div key={index}
                         data-aos="fade-zoom-in"
                         data-aos-duration="1000"
                         data-aos-delay={`${index * 100}`}
                         className="flex flex-col items-center justify-center w-40">
                        <img src={customer.image} className="h-28" alt={`Logo ${customer.title}`}/>
                    </div>)
                )}
            </div>
        </div>
    )
}

export default CustomerBrandSection;

const ProductTab = ({products, selectedProduct, onProductChange}) => {
    const {t} = useTranslation();
    return (
        <div className="flex text-xl font-bold place-content-center pt-8">
            <ul className="flex gap-2 justify-center place-content-center border-b-2 border-gray">
                {products.map((product, index) => (
                    <li key={index} onClick={() => onProductChange(product)}>
                        <Link to="">
                            <div className={`inline-block p-2 border-b-4 rounded-sm min-w-64
                                ${product.id === selectedProduct.id ?
                                "active border-primary text-primary" : "border-transparent text-grey"}`}>
                                {t(product.category)} </div>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    )
}
